import { ActionReducerMapBuilder, createSlice } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import getChallengesHandler from "./get-challenges.handler";
import actionChallengeHandler from "./action-challenges.handler";

type Counters = {
    rareTickets?: number;
    epicTickets?: number;
    legendaryTickets?: number;
    fragments?: number;
};

export interface IMilestone {
    threshold: number;
    reward: Counters;
    nonSum?: boolean;
}

export enum ChallengeCategory {
    Tutorial = 1,
    Periodical = 2,
    Static = 3,
}

export enum ChallengeType {
    SubscriptionReward = 1,
    EnterTheRegularDraw = 2,
    EnterTheRareDraw = 3,
    EnterTheEpicDraw = 4,
    EnterTheLegendaryDraw = 5,
}

export interface IChallenge {
    type: ChallengeType;
    category: ChallengeCategory;
    name: string;
    priority: number;
    progress: number;
    finishDate: number;
    milestones: IMilestone[];
}

export interface IChallengesState extends IRequestState {
    items: IChallenge[];
    tutorial?: {
        completed: number;
        total: number;
    }
};

const initialState: IChallengesState = {
    items: [],

    loading: false,
    error: "",
};

const challengesSlice = createSlice({
    name: 'challenges',
    initialState,
    reducers: {},
    extraReducers: (builder: ActionReducerMapBuilder<IChallengesState>) => {
        getChallengesHandler(builder);
        actionChallengeHandler(builder);
    },
});

export default challengesSlice.reducer;